import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'

export const useProfiles = () => {
  const { allProfilesList: lmsProfileList } = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles
  )

  const profiles = useMemo(() => {
    return lmsProfileList.map(({ id: value, name: label, color }) => ({
      value,
      label,
      color,
    }))
  }, [lmsProfileList])

  return { profiles }
}
